import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * Component to handle download link redirects
 * Fetches the original URL from the backend and redirects
 * Excluded from search engine indexing
 */
const DownloadRedirect = () => {
  const { shortId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOriginalUrl = async () => {
      try {
        // Get backend URL from environment or use default
        // In production, REACT_APP_API_URL should be set at build time
        // Fallback to the known backend URL if not set
        const backendUrl = process.env.REACT_APP_API_URL || 'https://snageasy-backend-5qh5zmmnxa-uc.a.run.app';
        
        console.log('Fetching original URL from:', `${backendUrl}/dl/${shortId}`);
        
        // Fetch original URL from backend (request JSON response)
        const response = await fetch(`${backendUrl}/dl/${shortId}`, {
          headers: {
            'Accept': 'application/json'
          },
          mode: 'cors' // Ensure CORS is enabled
        });
        
        if (response.ok) {
          const data = await response.json();
          if (data.originalUrl) {
            // Redirect to the original URL
            window.location.href = data.originalUrl;
          } else {
            setError('URL not found');
            setLoading(false);
          }
        } else if (response.status === 404) {
          setError('Short link not found');
          setLoading(false);
        } else {
          setError('Failed to fetch URL');
          setLoading(false);
        }
      } catch (err) {
        console.error('Error fetching original URL:', err);
        setError('Failed to load redirect URL');
        setLoading(false);
      }
    };

    if (shortId) {
      fetchOriginalUrl();
    } else {
      setError('Invalid short link');
      setLoading(false);
    }
  }, [shortId]);

  if (loading) {
    return (
      <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow, noarchive, nosnippet" />
          <meta name="googlebot" content="noindex, nofollow" />
        </Helmet>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          flexDirection: 'column',
          gap: '20px'
        }}>
          <div style={{ fontSize: '18px' }}>Redirecting...</div>
          <div style={{ fontSize: '14px', color: '#666' }}>Please wait while we redirect you to the download link.</div>
        </div>
      </>
    );
  }

  if (error) {
    return (
      <>
        <Helmet>
          <meta name="robots" content="noindex, nofollow, noarchive, nosnippet" />
          <meta name="googlebot" content="noindex, nofollow" />
        </Helmet>
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          flexDirection: 'column',
          gap: '20px'
        }}>
          <div style={{ fontSize: '18px', color: '#d32f2f' }}>Error: {error}</div>
          <button 
            onClick={() => navigate('/')}
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#1976d2',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Go to Home
          </button>
        </div>
      </>
    );
  }

  return null;
};

export default DownloadRedirect;

